import './list.css';

import React, { FunctionComponent as FC } from 'react';


export interface IListHeader {
  children: any;
};

const ListHeader: FC<IListHeader> = ({ children, ...props }) => {
  console.log(props);
  return <div className="list-header">{children}</div>;
};

export default ListHeader;
